import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconAlerts from './IconAlerts';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconAlerts, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/alert/demos/icon/IconAlerts.tsx",
    "fileName": "IconAlerts.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Alert from '@mui/material/Alert';\nimport CheckIcon from '@mui/icons-material/Check';\nimport CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';\nimport Stack from '@mui/material/Stack';\n\nexport default function IconAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Alert icon={<CheckIcon fontSize=\"inherit\" />} severity=\"success\">\n        This success Alert has a custom icon.\n      </Alert>\n      <Alert icon={false} severity=\"success\">\n        This success Alert has no icon.\n      </Alert>\n      <Alert\n        iconMapping={{\n          success: <CheckCircleOutlineIcon fontSize=\"inherit\" />,\n        }}\n      >\n        This success Alert uses `iconMapping` to override the default icon.\n      </Alert>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 24,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Alert from '@mui/material/Alert';\nimport CheckIcon from '@mui/icons-material/Check';\nimport CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';\nimport Stack from '@mui/material/Stack';\n\nexport default function IconAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Alert icon={<CheckIcon fontSize=\"inherit\" />} severity=\"success\">\n        This success Alert has a custom icon.\n      </Alert>\n      <Alert icon={false} severity=\"success\">\n        This success Alert has no icon.\n      </Alert>\n      <Alert\n        iconMapping={{\n          success: <CheckCircleOutlineIcon fontSize=\"inherit\" />,\n        }}\n      >\n        This success Alert uses `iconMapping` to override the default icon.\n      </Alert>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "CheckIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            "        This success Alert has a custom icon."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-bool",
                "false"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            "        This success Alert has no icon."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "iconMapping"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "success"
              ],
              ": <",
              [
                "span",
                "pl-c1 di-jsx",
                "CheckCircleOutlineIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />,"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            "        This success Alert uses `iconMapping` to override the default icon."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 24,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/Alert",
      "@mui/icons-material/Check",
      "@mui/icons-material/CheckCircleOutlined",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
